import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { ListGroup, Row, Col, Nav } from 'react-bootstrap';

import Tooltip from "../template/tooltip.js"
import GetPdf from '../reports/get-pdf.js'
import PrintPdf from '../reports/print-pdf.js'
import ActivityService from '../../service/activity-service'
import { ModalAlert } from '../template/modal-alert.js';
import i18n from "../../i18n";

import './perm-links.css'

export default class PermLinks extends Component {

	constructor(props) {
		super(props);

		if (i18n.languages[0] == 'hr') {
			this.state = {
				language: 1,
				showAlert: true
			}
		} else {
			this.state = {
				language: 2,
				showAlert: true
			}
		}

		this.handleAlertClose = this.handleAlertClose.bind(this);
		this.handleLanguageChange = this.handleLanguageChange.bind(this);
		this.triggerChildGetPdf = this.triggerChildGetPdf.bind(this);
		this.triggerChildPrintPdf = this.triggerChildPrintPdf.bind(this);
		this.isAvailable = this.isAvailable.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);

	}

	handleAlertClose() {
		this.setState({
			showAlert: false
		})
	}

	handleLanguageChange(prop) {
		this.setState({
			language: prop
		})
	}

	recordGetReportClick(reportType) {

		var simpleReport = 0;
		var detailedReport = 0;
		var diagnosticReport = 0;
		var linkId = null;

		if (reportType == 0) {
			simpleReport = 1;
			linkId = this.getLinkIdFromLink(this.props.permLinks.simpleReportLink);
		} else if (reportType == 1) {
			detailedReport = 1;
			linkId = this.getLinkIdFromLink(this.props.permLinks.detailedReportLink);
		} else {
			diagnosticReport = 1;
			linkId = this.getLinkIdFromLink(this.props.permLinks.diagnosticDataLink);
			diagnosticReport = 1;
		}

		ActivityService.recordActivity(1, 0, 0, 0, simpleReport, detailedReport, diagnosticReport, linkId).then(response => {
		}).catch(error => {
			ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
		});
	}

	triggerChildGetPdf(reportType, language) {

		if (!this.isAvailable()) {
			return;
		}

		if (reportType == 0) {
			this.refs.simpleChild.handleDownload(0, language);
		} else if (reportType == 1) {
			this.refs.detailedChild.handleDownload(1, language);
		} else {
			this.refs.diagnosticChild.handleDownload(2, language);
		}
	}

	triggerChildPrintPdf(reportType, language) {

		if (!this.isAvailable()) {
			return;
		}

		if (reportType == 0) {
			this.refs.simpleChildPrint.handlePrint(0, language);
		} else if (reportType == 1) {
			this.refs.detailedChildPrint.handlePrint(1, language);
		} else {
			this.refs.diagnosticChildPrint.handlePrint(2, language);
		}
	}

	isAvailable() {
		if (this.refs.simpleChild.state.downloading || this.refs.detailedChild.state.downloading || this.refs.diagnosticChild.state.downloading ||
			this.refs.simpleChildPrint.state.printing || this.refs.detailedChildPrint.state.printing || this.refs.diagnosticChildPrint.state.printing) {
			return false;
		}
		return true;
	}

	copyToClipboard(reportType, link) {
		var textField = document.createElement('textarea');
		textField.innerText = link;
		document.body.appendChild(textField);
		textField.select();
		document.execCommand('copy');
		textField.remove();

		var simpleReport = 0;
		var detailedReport = 0;
		var diagnosticReport = 0;
		var linkId = null;

		if (reportType == 0) {
			simpleReport = 1;
			linkId = this.getLinkIdFromLink(this.props.permLinks.simpleReportLink);
		} else if (reportType == 1) {
			detailedReport = 1;
			linkId = this.getLinkIdFromLink(this.props.permLinks.detailedReportLink);
		} else {
			diagnosticReport = 1;
			linkId = this.getLinkIdFromLink(this.props.permLinks.diagnosticDataLink);
		}

		ActivityService.recordActivity(0, 1, 0, 0, simpleReport, detailedReport, diagnosticReport, linkId).then(response => {
		}).catch(error => {
			ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
		});
	}

	getHashFromLink(link) {
		var splittedUrl = link.split("/");
		return splittedUrl[splittedUrl.length - 2];
	}

	getLinkIdFromLink(link) {
		var splittedUrl = link.split("/");
		return splittedUrl[splittedUrl.length - 1];
	}

	handleKeyUp(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			event.currentTarget.click();
		}
	}

	render() {
		return (
			<React.Fragment>
				{this.props.permLinks.numberOfSignatures == 0 && this.state.showAlert ?
					<div className="alert alert-danger" style={{ "marginLeft": "-15px", "marginRight": "-15px" }} role="alert" aria-atomic="true">
						<Row>
							<Col className="col-11 col-sm-11">
								{i18n.t("home:no_signatures")}
							</Col>
							<Col className="col-1 col-sm-1">
								<button onClick={this.handleAlertClose} type="button" style={{ "padding": "0px" }} className="btn float-right">
									<i className="material-icons">clear</i>
								</button>
							</Col>
						</Row>
					</div>
					:
					null
				}
				<Nav id="language" justify variant="pills" defaultActiveKey={i18n.languages[0]} style={{ "marginLeft": "-15px", "marginRight": "-15px" }}>
					<Nav.Item>
						<Nav.Link eventKey="hr" onSelect={() => this.handleLanguageChange(1)}>{i18n.t("home:cro")}</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="en" onSelect={() => this.handleLanguageChange(2)}>{i18n.t("home:eng")}</Nav.Link>
					</Nav.Item>
				</Nav>

				<ListGroup>
					<ListGroup.Item className="row" active style={{ backgroundColor: "#3f5c94" }}>
						{i18n.t("home:validation_reports")}
					</ListGroup.Item>
					<ListGroup className="list-group-horizontal row text-center text-sm-left">

						<ListGroup.Item className="col-lg-9 col-sm-6 col-xs-12 mr-0" action onClick={() => { window.open(this.props.permLinks.simpleReportLink + "/" + this.state.language, "_blank"), this.recordGetReportClick(0) }}>
							<i className="align-middle material-icons" aria-hidden="true">insert_drive_file</i>
							<span className="align-middle">{i18n.t("home:simple_report")}</span>
						</ListGroup.Item>


						<ListGroup.Item id="simple-copy_simple" aria-label={i18n.t("home:copy_simple")} className="col-lg-1 col-sm-2 col-xs-4 text-center mr-0" action onClick={() => this.copyToClipboard(0, this.props.permLinks.simpleReportLink + "/" + this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:copy_simple")}>
								<i className="align-middle material-icons">content_copy</i>
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item aria-label={i18n.t("home:download_simple")} className="col-lg-1 col-sm-2 col-xs-4 listGroupItemGetPdfFina mr-0" action onClick={() => this.triggerChildGetPdf(0, this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:download_simple")}>
								<GetPdf ref="simpleChild" hash={this.getHashFromLink(this.props.permLinks.simpleReportLink)}
									linkId={this.getLinkIdFromLink(this.props.permLinks.simpleReportLink)}
									documentName={this.props.documentName} reportType={1} button={false} />
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item aria-label={i18n.t("home:print_simple")} className="col-lg-1 col-sm-2 col-xs-4 text-center mr-0" action onClick={() => this.triggerChildPrintPdf(0, this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:print_simple")}>
								<PrintPdf ref="simpleChildPrint" hash={this.getHashFromLink(this.props.permLinks.simpleReportLink)}
									linkId={this.getLinkIdFromLink(this.props.permLinks.simpleReportLink)}
									documentName={this.props.documentName} reportType={1} />
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item className="col-lg-9 col-sm-6 col-xs-12 mr-0" action onClick={() => { window.open(this.props.permLinks.detailedReportLink + "/" + this.state.language, "_blank"), this.recordGetReportClick(1) }}>
							<i className="align-middle material-icons" aria-hidden="true">insert_drive_file</i>
							<span className="align-middle">{i18n.t("home:detailed_report")}</span>
						</ListGroup.Item>


						<ListGroup.Item aria-label={i18n.t("home:copy_detailed")} className="col-lg-1 col-sm-2 col-xs-4 text-center mr-0" action onClick={() => this.copyToClipboard(1, this.props.permLinks.detailedReportLink + "/" + this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:copy_detailed")}>
								<i className="align-middle material-icons">content_copy</i>
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item aria-label={i18n.t("home:download_detailed")} className="col-lg-1 col-sm-2 col-xs-4 listGroupItemGetPdfFina mr-0" action onClick={() => this.triggerChildGetPdf(1, this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:download_detailed")}>
								<GetPdf ref="detailedChild" hash={this.getHashFromLink(this.props.permLinks.detailedReportLink)}
									linkId={this.getLinkIdFromLink(this.props.permLinks.detailedReportLink)}
									documentName={this.props.documentName} reportType={2} button={false} />
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item aria-label={i18n.t("home:print_detailed")} className="col-lg-1 col-sm-2 col-xs-4 text-center mr-0" action onClick={() => this.triggerChildPrintPdf(1, this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:print_detailed")}>
								<PrintPdf ref="detailedChildPrint" hash={this.getHashFromLink(this.props.permLinks.detailedReportLink)}
									linkId={this.getLinkIdFromLink(this.props.permLinks.detailedReportLink)}
									documentName={this.props.documentName} reportType={2} />
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item className="col-lg-9 col-sm-6 col-xs-12 mr-0" action onClick={() => { window.open(this.props.permLinks.diagnosticDataLink + "/" + this.state.language, "_blank"), this.recordGetReportClick(2) }}>
							<i className="align-middle material-icons" aria-hidden="true">insert_drive_file</i>
							<span className="align-middle">{i18n.t("home:diagnostic_report")}</span>
						</ListGroup.Item>

						<ListGroup.Item aria-label={i18n.t("home:copy_diagnostic")} className="col-lg-1 col-sm-2 col-xs-4 text-center mr-0" action onClick={() => this.copyToClipboard(2, this.props.permLinks.diagnosticDataLink + "/" + this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:copy_diagnostic")}>
								<i className="align-middle material-icons">content_copy</i>
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item aria-label={i18n.t("home:download_diagnostic")} className="col-lg-1 col-sm-2 col-xs-4 listGroupItemGetPdfFina mr-0" action onClick={() => this.triggerChildGetPdf(2, this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:download_diagnostic")}>
								<GetPdf ref="diagnosticChild" hash={this.getHashFromLink(this.props.permLinks.diagnosticDataLink)}
									linkId={this.getLinkIdFromLink(this.props.permLinks.diagnosticDataLink)}
									documentName={this.props.documentName} reportType={3} button={false} />
							</Tooltip>
						</ListGroup.Item>

						<ListGroup.Item aria-label={i18n.t("home:print_diagnostic")} className="col-lg-1 col-sm-2 col-xs-4 text-center mr-0" action onClick={() => this.triggerChildPrintPdf(2, this.state.language)}>
							<Tooltip trigger={['focus', 'hover']} placement="auto" tooltip={i18n.t("home:print_diagnostic")}>
								<PrintPdf ref="diagnosticChildPrint" hash={this.getHashFromLink(this.props.permLinks.diagnosticDataLink)}
									linkId={this.getLinkIdFromLink(this.props.permLinks.diagnosticDataLink)}
									documentName={this.props.documentName} reportType={3} />
							</Tooltip>
						</ListGroup.Item>
					</ListGroup>

				</ListGroup>
			</React.Fragment >
		);
	}
}

